class ConmanagerDetails {

    constructor() {
    }

    observeStickyRegisterButton(stickyElementSelector) {
        let stickyRegisterButton = document.querySelector(stickyElementSelector);

        if (null === stickyRegisterButton) {
            return;
        }

        let observer = new IntersectionObserver(
            ([e]) => e.target.classList.toggle('isSticky', e.intersectionRatio < 1),
            {
                rootMargin: '0px 0px -41px 0px',
                // root: document.querySelector('footer'),
                threshold: 1
            }
        );

        observer.observe(stickyRegisterButton);

    }
}

export default ConmanagerDetails;